/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_5_ResendInputs */

const en_privacy_section_5_resend = /** @type {(inputs: Privacy_Section_5_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend`)
};

const lv_privacy_section_5_resend = /** @type {(inputs: Privacy_Section_5_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend`)
};

/**
* | output |
* | --- |
* | "Resend" |
*
* @param {Privacy_Section_5_ResendInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_5_resend = /** @type {((inputs?: Privacy_Section_5_ResendInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_5_ResendInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_5_resend(inputs)
	return en_privacy_section_5_resend(inputs)
});